// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1AAFp","modalFooterButton":"ModalNotes_modalFooterButton__19Pix"};